<div class="accordion" id="accordionExample" style="margin-top: -25px;">

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading11">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse11" aria-expanded="false" aria-controls="collapse11">
                Schenken en notariële akte
            </button>
        </h2>
        <div id="collapse11" class="accordion-collapse collapse" aria-labelledby="heading11"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                In sommige gevallen is een notariële akte verplicht of wenselijk bij een schenking, zoals bij:
                <ul>
                    <li>Schenkingen op papier (schuldigerkenning)</li>
                    <li>Schenkingen met een opschortende voorwaarde</li>
                    <li>Schenkingen van onroerend goed of beperkte rechten daarop</li>
                    <li>Periodieke schenkingen die aftrekbaar zijn voor de inkomstenbelasting</li>
                </ul>
                De notaris stelt een akte op en meldt de schenking vaak aan de Belastingdienst. Toch blijft de ontvanger
                verantwoordelijk voor de aangifte.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading12">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse12" aria-expanded="false" aria-controls="collapse12">
                CDR-nummer
            </button>
        </h2>
        <div id="collapse12" class="accordion-collapse collapse" aria-labelledby="heading12"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Het CDR-nummer (Centraal Digitaal Repertorium-nummer) is een uniek nummer dat notariële akten
                identificeert.
                <div class="space20"></div>
                Het wordt toegekend door de Koninklijke Notariële Beroepsorganisatie (KNB). Bij een schenking via de
                notaris kan het CDR-nummer gevraagd worden op het aangifteformulier schenkbelasting om de schenking te koppelen
                aan de juiste akte.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading13">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse13" aria-expanded="false" aria-controls="collapse13">
                Protocolnummer notaris
            </button>
        </h2>
        <div id="collapse13" class="accordion-collapse collapse" aria-labelledby="heading13"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Het protocolnummer is het registratienummer dat de notaris zelf toekent aan elke opgemaakte akte in zijn
                protocol. Dit nummer, samen met het jaartal en de naam van de notaris, maakt het mogelijk om een specifieke akte
                snel terug te vinden.
                <div class="space20"></div>
                Het protocolnummer kan gevraagd worden bij het invullen van de schenkbelasting als de
                schenking via een notariële akte is verlopen.
            </div>
        </div>
    </div>

</div>
